import { API_config } from '../../config/apiConfig';

/**
 * Fetch all geofences from Traccar API
 * @returns {Promise<Array>} List of geofences
 */
export async function fetchGeofences() {
    try {
        const response = await fetch(`${API_config.apiUrl}/geofences`, {
            method: 'GET',
            headers: {
                'Authorization': API_config.authHeader,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch geofences error:', error);
        throw error;
    }
}

/**
 * Create a new geofence
 * @param {Object} geofence - Geofence object
 * @returns {Promise<Object>} Created geofence
 */
export async function createGeofence(geofence) {
    try {
        const response = await fetch(`${API_config.apiUrl}/geofences`, {
            method: 'POST',
            headers: {
                'Authorization': API_config.authHeader,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(geofence)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Create geofence error:', error);
        throw error;
    }
}

/**
 * Update an existing geofence
 * @param {Object} geofence - Geofence object (must include id)
 * @returns {Promise<Object>} Updated geofence
 */
export async function updateGeofence(geofence) {
    try {
        const response = await fetch(`${API_config.apiUrl}/geofences/${geofence.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': API_config.authHeader,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(geofence)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Update geofence error:', error);
        throw error;
    }
}

/**
 * Delete a geofence
 * @param {number} id - Geofence ID
 * @returns {Promise<void>}
 */
export async function deleteGeofence(id) {
    try {
        const response = await fetch(`${API_config.apiUrl}/geofences/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': API_config.authHeader,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Delete geofence error:', error);
        throw error;
    }
}
